module.exports = __webpack_public_path__ + "img/upload_picture.d16d9387.png";